var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.onePassword)?_c('AuthQrCode',{attrs:{"connection-id":_vm.connectionId}}):_vm._e(),(_vm.onePassword)?_c('TablePrompter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }